<button type="button"
        role="checkbox"
        [attr.aria-checked]="checked()"
        [disabled]="disabled()"
        (click)="toggle()">
  @if (checked()) {
    <yo-icon icon="check" size="small"></yo-icon>
  }
</button>
